
/*仓储物流管理系统*/

/*主容器文件*/
const main = () =>  import("../../../studio/sub_systems/warehousing/warehousing_system_main");

/*仓储物流管理  首页子系统*/
const main_container = () =>  import("../../../studio/sub_systems/warehousing/index_page/index_page_main");
// 入库明细
const inbound = () =>  import("../../../studio/sub_systems/warehousing/index_page/inbound/inbound_main");
// 入库审核
const inboundVerify = () =>  import("../../../studio/sub_systems/warehousing/index_page/inbound/inbound_verify");
// 出库管理
const outbound = () =>  import("../../../studio/sub_systems/warehousing/index_page/outbound/outbound_main");
// 入库审核
const outboundVerify = () =>  import("../../../studio/sub_systems/warehousing/index_page/outbound/outbound_verify");
// 仓库管理
const warehouse = () =>  import("../../../studio/sub_systems/warehousing/index_page/warehouse/warehouse");
// 库存管理
const stock = () =>  import("../../../studio/sub_systems/warehousing/index_page/stock/warehouse");
const warehouseMap = () =>  import("../../../studio/sub_systems/warehousing/index_page/warehouse/map");

export default [
  {
    path: '/warehousing',
    name: '仓储物流管理系统',
    redirect: '/warehousing/inbound',
    component: main,
    children: [
      {
        path: '/warehousing/inbound',
        redirect: '/warehousing/inbound/index',
        name: '首页',
        component: main_container,
        children:[
          {
            path: '/warehousing/inbound',
            name: '入库管理',
            redirect: '/warehousing/inbound/index',
            component: inbound ,
          },
          {
            path: '/warehousing/inbound/index',
            name: '入库明细',
            component: inbound ,
          },
          {
            path: '/warehousing/inbound/verify',
            name: '入库审核',
            component: inboundVerify ,
          },
          {
            path: '/warehousing/outbound',
            redirect: '/warehousing/outbound/index',
            name: '出库管理',
            component: outbound ,
          },
          {
            path: '/warehousing/outbound/index',
            name: '出库明细',
            component: outbound ,
          },
          {
            path: '/warehousing/outbound/verify',
            name: '出库审核',
            component: outboundVerify ,
          },
          {
            path: '/warehousing/index/stock',
            name: '库存管理',
            component: stock ,
          },
          {
            path: '/warehousing/index/warehouse',
            name: '仓库管理',
            component: warehouse ,
          },
          {
            path: '/warehousing/index/map',
            name: '仓库地图',
            component: warehouseMap ,
          },
        ]
      },

    ]
  },

]



// WEBPACK FOOTER //
// ./src/router/modules/warehousing/warehousing_system_page.js